import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';

export default class PriceList {
  constructor(priceList, airportCode) {
    this.priceList = priceList;
    this.airportCode = airportCode;
    return this;
  }

  getDataForBusStop(busStopKey) {
    return this.priceList.bus_stops[this.airportCode][busStopKey];
  }

  getDataForPostcode(postcode) {
    return this.priceList[this.airportCode][postcode];
  }

  getAddressData(busStopName, postcode) {
    if (isEmpty(busStopName)) {
      //check price for postcode
      var data = this.getDataForPostcode(postcode);
    } else {
      //check by bus stop
      var data = this.getDataForBusStop(busStopName);
    }
    return data;
  }

  isAddressSupported(busStopName, postcode) {
    var data = this.getAddressData(busStopName, postcode);

    if (isEmpty(data)) {
      // the address is not supported
      return false;
    } else {
      return true;
    }
  }

  isBusStopSupported(busStopName) {
    return this.getDataForBusStop(busStopName) !== undefined;
  }

  getTotalPrice(params) {
    var defaultParams = { busStopName: '', postcode: '', adults: 0, children: 0, students: 0 };
    var params = merge(defaultParams, params);

    if (isEmpty(params.busStopName) && isEmpty(params.postcode)) {
      return null;
    }

    var data = this.getAddressData(params.busStopName, params.postcode);
    if (isEmpty(data)) {
      // the address is not supported
      return false;
    } else {
      return this.calculateTotalPrice(data, params.adults, params.children, params.students);
    }
  }

  calculateTotalPrice(data, adultsParam, childrenParam, studentsParam) {
    var adultsNumber = this.convertToInt(adultsParam);
    var childrenNumber = this.convertToInt(childrenParam);
    var studentsNumber = this.convertToInt(studentsParam);
    var studentsSum = data.students * studentsNumber;
    return data.adults * adultsNumber + data.kids * childrenNumber + studentsSum;
  }

  convertToInt(param) {
    var value = parseInt(param);
    if (isNaN(value)) {
      return 0;
    } else {
      return value;
    }
  }

}
